import * as echarts from "echarts";
export function deviceOption(
  name = "",
  xData = [],
  yData = [],
  unit = "",
  indexs = []
) {
  let max,
    min,
    seriesData = [];
  if (xData.length > 0 && yData.length > 0) {
    max = Number(Math.max(...yData).toFixed(0));
    min = Math.min(...yData);
    yData.map((item, idx) => {
      seriesData.push([indexs[idx], yData[idx]]);
    });
  }
  return {
    color: ["#02cdff"],
    textStyle: {
      fontSize: 18
    },
    grid: {
      left: "12%",
      right: "7%",
      // bottom: "14%",
      bottom: "17%",
      top: "18%"
    },
    tooltip: {
      trigger: "axis"
    },
    xAxis: [
      {
        type: "category",
        name: unit,
        nameLocation: "end",
        nameTextStyle: {
          color: "#fff",
          fontSize: 12,
          padding: [0, -6, -20]
        },
        boundaryGap: false,
        axisLabel: {
          color: "#fff"
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: "#397cbc"
          }
        },
        data: xData
      }
    ],
    yAxis: [
      {
        type: "value",
        name: name,
        nameTextStyle: {
          fontSize: "15px",
          padding: [0, 0, -10, 0]
        },
        axisLine: {
          lineStyle: {
            color: "#fff"
          }
        },
        max: max + 1,
        min: min
      }
    ],
    series: [
      {
        type: "line",
        symbolSize: 1,
        smooth: true,
        itemStyle: {
          normal: {
            areaStyle: {
              //color: '#94C9EC'
              color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                {
                  offset: 0,
                  color: "rgba(7,46,101,0.3)"
                },
                {
                  offset: 1,
                  color: "rgba(0,166,246,0.9)"
                }
              ])
            }
          }
        },
        data: seriesData
      }
    ]
  };
}
